import type {IntlShape} from 'react-intl';

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * The day the AI allowance resets, from the gateway's `period_end` (YYYY-MM-DD). Read as a local
 * calendar date: read as a UTC instant it names the previous day anywhere west of UTC. Null for
 * anything that is not a real date.
 */
export const creditsResetDate = (resetsOn: string | null | undefined): Date | null => {
	const match = resetsOn ? ISO_DATE.exec(resetsOn) : null;
	if (!match) return null;
	const [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])];
	const date = new Date(year, month - 1, day);
	return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
};

/** The reason every disabled Nova control gives while the allowance is spent. */
export const formatCreditsReason = (
	intl: Pick<IntlShape, 'formatMessage' | 'formatDate'>,
	resetsOn: string | null | undefined
): string => {
	const date = creditsResetDate(resetsOn);
	if (!date) return intl.formatMessage({id: 'nova_invocation.control.reason_out_of_credits_no_date'});
	return intl.formatMessage(
		{id: 'nova_invocation.control.reason_out_of_credits'},
		{date: intl.formatDate(date, {day: 'numeric', month: 'long', year: 'numeric'})}
	);
};
